import { ICheckboxCtx } from './../../shared/form/checkbox/checkbox.component';
import { Validators, FormArray, FormControl, FormGroup } from '@angular/forms';
import { getValue } from '../mappers';
import {
  IAutocompleteCtx,
  IInputCtx,
  IMultiTagsCtx,
  ISelectCtx,
  ITagsCtx,
  ITextCtx
} from '../../shared/form';
import { of } from 'rxjs';
import { AutoCompleteService } from '../../core/services/autocomplete.service';
import { map } from 'rxjs/operators';
import { IOption } from './organization.service';

export class OrganizationForm {
  readonly fields = {
    name: new FormControl(null, [Validators.required]),
    type: new FormControl(null, [Validators.required]),
    remote: new FormControl(null),
    country: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    zip: new FormControl(null, [Validators.required]),
    address: new FormControl(null, [Validators.required]),
    phone: new FormControl(),
    webSite: new FormControl(),
    members: new FormArray([]),
    alter: new FormArray([]),
    tags: new FormArray([], [Validators.required, Validators.minLength(1)]),
    about_me: new FormControl()
  };

  readonly form = new FormGroup(this.fields);
  public file: File;

  readonly name: IInputCtx = {
    control: this.fields.name,
    placeholder: `Organization Title / Name`,
    hint: `Rushmore Academy`
  };

  readonly type: ISelectCtx<string> = {
    placeholder: `Organization Type`,
    control: this.fields.type,
    getTitle: (value) => value,
    options: of([
      `School`,
      `Pre-school/kindergarten`,
      `University`,
      `After-school`,
      `Summer camp/program`,
      `Tutoring agency`,
      `Sport academy/club`,
      `Education consultancy`,
      `Student organization`,
      'Other'
    ])
  };

  readonly country = this.auto.getCountry(this.fields.country);
  readonly city = this.auto.getCity(this.fields.city);

  readonly zip: IInputCtx = {
    control: this.fields.zip,
    placeholder: `Zip / Post Code`
  };

  readonly address: IAutocompleteCtx<IOption> = {
    control: this.fields.address,
    placeholder: `Detailed Address`,
    getTitle: getValue,
    // hint: `street, number build & etc.`,
    options: of([])
  };

  readonly phone: IInputCtx = {
    control: this.fields.phone,
    placeholder: `Organization's Main Phone Number`
  };

  readonly webSite: IInputCtx = {
    control: this.fields.webSite,
    placeholder: `Web Site`
  };

  readonly members: IMultiTagsCtx<[string, string]> = {
    inputs: [
      {
        control: new FormControl(``),
        getTitle: (value) => value + ``,
        options: of([]),
        placeholder: `Title of members`
      },
      {
        control: new FormControl(``),
        getTitle: (value) => value + ``,
        options: of([]),
        placeholder: `Value`
      }
    ],
    map: ([title, count]) => [title, count],
    getTitle: ([title, count]) => `${title} @ ${count}`,
    values: this.fields.members
  };

  readonly alterInput = new FormControl(``);
  readonly alter: IMultiTagsCtx<any> = {
    inputs: [
      {
        control: this.alterInput,
        getTitle: ({ value }) => value,
        options: this.auto.getOptions(this.alterInput, `get/field/names`),
        placeholder: `Alternative names for your organization`,
        hint: `Kumon USA or Kumon North America Inc. or Kumon International`
      }
    ],
    map: ([value]) => value,
    getTitle: getValue,
    values: this.fields.alter,
    isDisabled: this.alterInput.valueChanges.pipe(
      map((value) => typeof value !== 'object')
    )
  };

  readonly tags: ITagsCtx = {
    control: this.fields.tags,
    placeholder: `Tags`,
    hint: `STEM, business, summer program`
  };

  readonly remote: ICheckboxCtx = {
    control: this.fields.remote,
    placeholder: `Remote`
  };

  readonly aboutMe: ITextCtx = {
    control: this.fields.about_me,
    placeholder: `About Us`,
    maxLength: 1000
  };

  constructor(readonly auto: AutoCompleteService) {}

  public getFormData() {
    const object = this.form.value;
    const mapped = {
      name: object.name,
      member: object.type,
      country: getValue(object.country),
      city: getValue(object.city),
      zip: object.zip,
      address: getValue(object.city),
      phone: object.phone,
      www: object.webSite,
      names: object.alter.map(({ id }) => id),
      interest: object.tags,
      remote: !!object.remote,
      about: object.about_me,
      acredit_file: this.file,
      data_name: [],
      data_value: []
    };

    for (const [test, score] of object.members) {
      mapped.data_name.push(test);
      mapped.data_value.push(score);
    }

    return mapped;
  }
}
